namespace Portico.Directives {

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;

	export interface ITcDownloadController {
		clazz: string;
		file: string;
		label: string;
		method: string;
		type: string;
    }

    export class TcDownloadController implements ITcDownloadController {
        clazz: string;
		file: string;
        label: string;
		method: string;
		type: string;
    }

    angular.module('app').directive('tcDownload', [
        '$compile',
        '$state',
		'dataService',
        'serverConstants',
		(
            $compile: angular.ICompileService,
            $state: angular.ui.IStateService,
			dataService: ps.IDataService,
            serverConstants: pmi.IServerConstants
		) => {
			return {
				bindToController: {
					clazz: '@',
					file: '@',
					label: '@',
					method: '@',
					type: '@',
				},
				controller: <any>TcDownloadController,
				controllerAs: '$download',
				link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[], $transclude: angular.ITranscludeFunction) => {
					const tcDownload: ITcDownloadController = $ctrl[0];
					
					const clazz = tcDownload.clazz ? tcDownload.clazz : '';
					const file = tcDownload.file ? tcDownload.file : '';
					const label = tcDownload.label ? tcDownload.label : '';
					const method = tcDownload.method ? tcDownload.method : 'post';
					const programId = dataService.getProgramId();
					const type = tcDownload.type ? tcDownload.type : '';
					let transclusion = '';					
					let html = '';

					$transclude(function (clone) {
                        clone.each(function (index, node) {
                            transclusion += node.textContent ? node.textContent : node.outerHTML;
                        });
                    });

					transclusion = transclusion.trim() || label;

					if (type === 'document') {
						if (method === 'get') {
							html =
								`<a class="${clazz}" href="${serverConstants.root}file/downloadDocument/${programId}/${file}" target="_blank">${transclusion}</a>`;
						} else {
							html =
								`<form action="${serverConstants.root}file/downloadDocument" method="POST">
									<input name="id" type="hidden" value="${programId}" />
									<input name="id2" type="hidden" value="${file}" />
									<a class="${clazz}" onclick="this.parentElement.submit();" role="button">${transclusion}</a>																		
								</form>`;
						}
					} else {
						if (method === 'get') {
							html =
								`<a class="${clazz}" href="${serverConstants.root}file/download?filename=${file}" target="_blank">${transclusion}</a>`;
						} else {
							html =
								`<form action="${serverConstants.root}file/download" method="POST">
									<input name="filename" type="hidden" value="${file}" />
									<a class="${clazz}" onclick="this.parentElement.submit();" role="button">${transclusion}</a>									
								</form>`;
						}
					}					
					
					$compile($element.contents() as any)($scope);
					$element.html(html);					
				},
				replace: true,
				require: ['tcDownload'],				
				restrict: 'E',
				scope: true,
				transclude: true
			};
		}
	]);
}